import FormControlLabel from '@mui/material/FormControlLabel'
import { styled } from '@mui/material/styles'
import { apiURI } from 'src/lib/utils/constants'
import axios from 'axios'
import Cookies from 'js-cookie'
import { constants } from 'src/lib/utils/constants'
import { SWRConfiguration } from 'swr'

export const StyledFormControlLabel = styled(FormControlLabel)({
  '& .MuiFormControlLabel-label': {
    fontSize: '14px',
    fontWeight: 400
  },
  '& .MuiRadio-root': {
    height: '18px'
  },
  marginBottom: '12px',
  '&:last-child': {
    marginBottom: 0
  }
})

export const checkoutNodeFetcher: SWRConfiguration['fetcher'] = async (url: string) => {
  const response = await axios.get(url, {
    baseURL: apiURI.CHECKOUT_NODE,
    headers: { Authorization: Cookies.get(constants.AUTH_COOKIE_CLIENT) ?? '' }
  })
  return response.data
}
